import { AdminBlockResponse } from "../contracts/AdminBlockResponse";

/** One member of an instructor's organization, with parsed dates. */
export interface AdminMember {
  id: string;
  firstName: string;
  lastName: string;
  email: string | null;
  isMinor: boolean;
  tags: string[];
  dateCreated: Date;
  /** The platform's active block on the member (US-111); null when not blocked. */
  block: AdminBlockResponse | null;
}

/** An instructor account with the members of its organization, newest first. */
export interface AdminUserMembers {
  instructorId: string;
  firstName: string;
  lastName: string;
  email: string;
  members: AdminMember[];
}

/** Full instructor name, falling back to the email. */
export const adminUserMembersOwnerName = (detail: AdminUserMembers): string => {
  const name = `${detail.firstName} ${detail.lastName}`.trim();
  return name.length > 0 ? name : detail.email;
};
